import React from 'react'
import PageBanner from '../Common/PageBanner'
import NavbarStyleFour from './NavbarStyleFour'
import Footer from './Footer'
import DGFTIEC from '../../public/Awards/1.png'
import ExcellenceAwards from '../../public/Awards/2.png'
import { Card } from 'react-bootstrap';


const Awards = () => {
  return (
    <>
      <NavbarStyleFour />
      <PageBanner pageTitle="OUR RECOGNITIONS" />
    <div className="container">
      <div className="row">
        <div className="col-md-3 me-4 col-12" >
        <div class="card" style={{ width: '16rem' }}>
       <div className='text-center'>
       <img class="p-3" src={DGFTIEC} alt="card" />
       </div>
        <div class="card-body">
          <p className="text-primary">DGFTIEC</p>
          <h5 class="card-title">DGFTIEC</h5>
          <p class="card-text">Skill Tech is granted IEC (Importer -Exporter Code) by DGFT</p>
        </div>
      </div>
        </div>
        <div className="col-md-3 ml-3 col-12">
        <div class="card" style={{ width: '16rem' }}>
       <div className='text-center'>
       <img class="p-3" src={ExcellenceAwards} alt="card" />
       </div>
        <div class="card-body">
          <p className="text-primary">Excellence Awards</p>
          <h5 class="card-title">Excellence Awards</h5>
          <p class="card-text">Received excellence award form many major clients</p>
        </div>
      </div>
        </div>
      </div>
    </div>
      <Footer />
    </>
  )
}

export default Awards